<template>
    <BarChart v-bind:title="title" v-bind:data="data"/>
</template>

<script>
import BarChart from "@/components/management/statistics/common/BarChart";
import {getWebHelpChartData} from "@/api/statistics";

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      title : 'WebHelp View',
      data : [],
    };
  },
  // created() {
  //   this.getData();
  // },
  methods: {
    async getData(year, firstDoctype, firstProdType, secondProdType) {
      let loader = this.$loading.show({});
      try {
        let response = await getWebHelpChartData(year, firstDoctype, firstProdType, secondProdType);
        console.log(response);
        this.data = response.data.result;
      } finally {
        loader.hide();
      }
    },
  }
};
</script>

<style>
</style>
